module.exports = __webpack_public_path__ + "assets/images/avatar_saude_preventiva.cd54e97c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/avatar_saude_preventiva.png
// module id = 682
// module chunks = 1